import React, { useEffect,useState} from "react";
import { Typography, TextField, FormControl, Box, Chip, Button, Divider, Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerByid,fetchCustomerAppByid } from "../../redux/Slice/customerSlice";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { updateCustomerSubscription } from "../../redux/Slice/cusSubcription";
import { toast } from "sonner";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { clearMessage } from "../../redux/Slice/message";
import { updatePlan } from "../../redux/Slice/planslice";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";


const PlanDetails = () => {
  const { id } = useParams(); 
  const dispatch = useDispatch();
  const { customerDetail } = useSelector((state) => state.customer);
  console.log("customerDetail:",customerDetail);
  
  const message = useSelector((state) => state.message);
  

// console.log("customer:",customer?.plans)

// console.log("customer:",customer?.plans)

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])
  
  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(fetchCustomerByid({c_id:id}))
    .then(() => dispatch(setLoading(false)))  
    .catch(() => dispatch(setLoading(false)));
  }, [dispatch, id]);

  
 

  const companyName = customerDetail?.companyName || "N/A";
  const plans = customerDetail?.plans || [];
  console.log("Plans:",plans);
  

  if (plans.length === 0) return <Typography>No plans found for this customer.</Typography>;

  // const handleActivatePlan = async (planId) => {
  //   dispatch(setLoading(true));
  
  //   const currentlyActivePlan = plans.find((plan) => plan.active);
  
  //   const selectedPlan = plans.find((plan) => plan._id === planId);
  //   if (!selectedPlan) return;
  
  //   // If the selected plan is already active, do nothing
  //   if (selectedPlan.active) {
  //     dispatch(updateCustomerSubscription({ id, subscriptionPlan: planId }));

  const handleActivatePlan = async (planId) => {
    dispatch(setLoading(true));
  
    const currentlyActivePlan = plans.find((plan) => plan.active);
  
    const selectedPlan = plans.find((plan) => plan._id === planId);
    if (!selectedPlan) return;
  
    // If the selected plan is already active, do nothing
    if (selectedPlan.active) {
      dispatch(updateCustomerSubscription({ id, subscriptionPlan: planId }));
      dispatch(setLoading(false));
      return;
    }

    if (currentlyActivePlan) {
      await dispatch(updatePlan({ id: currentlyActivePlan._id, formData: { active: false } }));
    }

    await dispatch(updatePlan({ id: planId, formData: { active: true } }));

    dispatch(updateCustomerSubscription({ id, subscriptionPlan: planId }));

    dispatch(fetchCustomerByid({ c_id: id }))
    .then(() => dispatch(setLoading(false)))  
    .catch(() => dispatch(setLoading(false)));
  
  
     
    if (currentlyActivePlan) {
      await dispatch(updatePlan({ id: currentlyActivePlan._id, formData: { active: false } }));
    }

    await dispatch(updatePlan({ id: planId, formData: { active: true } }));

    dispatch(updateCustomerSubscription({ id, subscriptionPlan: planId }));

    dispatch(fetchCustomerByid({ c_id: id }))
    .then(() => dispatch(setLoading(false)))  
    .catch(() => dispatch(setLoading(false)));
  };




  // const columns = [
  //   { id: "serviceName", label: "Service Name", minWidth: 150 },
  //   { id: "feature", label: "Features", minWidth: 200 },
  //   { id: "quantity", label: "Quantity", minWidth: 100 },
  //   { id: "templates", label: "Templates", minWidth: 250 },
  // ];

  // // Transform services data into a structured table format
  // const rows = services.flatMap((service) =>
  //   service.features.map((feature) => ({
  //     serviceName: service.serviceId.name,
  //     feature: feature.key,
  //     quantity: feature.value || "N/A",
  //     templates: service.template?.map((tpl, index) => (
  //       <Chip key={index} label={tpl.templateName || "N/A"} sx={{ marginRight: 1 }} />
  //     )),
  //   }))
  // );

  const TemplateList = ({ title, templates }) => (
    <Grid item size={4}>
      <Typography variant="h6">{title}</Typography>
      <Box marginY={2}>
        <List>
          {templates?.map((tpl, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                { <DescriptionIcon />} 
              </ListItemIcon>
              <ListItemText primary={tpl.name || tpl.templateName || "N/A"} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Grid>
  );
  
  

  return (
    <Grid container spacing={2} sx={{ padding: "20px"}}>
      <Grid item size={12}>
        <Typography variant="h4" gutterBottom>
          View Plan Details for {companyName}
        </Typography>
      </Grid>

      {/* Customer Name */}
      {/* <Grid item size={12}>
        <FormControl fullWidth margin="normal">
          <Typography variant="subtitle1">Customer</Typography>
          <TextField value={companyName} slotProps={{ input: { readOnly: true } }} sx={{width:"50%"}} />
        </FormControl>
      </Grid> */}

      {plans.map((plan, index) => {
        const { _id, name, price, services, showcaseTemplate,expiredDays,productTemplate,inspirationTemplate } = plan;
        return (
          <React.Fragment key={index}>
          <Grid item size={12}>
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                paddingX: 4,
                paddingY:2
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h5">
                  Plan {index + 1}: {name}
                </Typography>
        
                <Button
                  onClick={() => handleActivatePlan(_id)}
                  sx={{
                    backgroundColor: plan.active ? "#2FB354" : "#d3d3d3",
                    color: "white",
                    "&:hover": { backgroundColor: plan.active ? "#2FB354" : "#a9a9a9" },
                  }}
                  disabled={plan.active}
                >
                  {plan.active ? "Active" : "Activate"}
                </Button>
              </Box>
        
              <Grid container spacing={2} sx={{ marginTop: 2 }}>
                <Grid item size={4}>
                  <FormControl fullWidth margin="normal">
                    <Typography variant="subtitle1">Plan Name</Typography>
                    <TextField value={name} slotProps={{ input: { readOnly: true } }} fullWidth />
                  </FormControl>
                </Grid>
        
                <Grid item size={4}>
                  <FormControl fullWidth margin="normal">
                    <Typography variant="subtitle1">Plan Price</Typography>
                    <TextField value={price} slotProps={{ input: { readOnly: true } }} fullWidth />
                  </FormControl>
                </Grid>
        
                <Grid item size={4}>
                  <FormControl fullWidth margin="normal">
                    <Typography variant="subtitle1">Expiry Day</Typography>
                    <TextField value={expiredDays} slotProps={{ input: { readOnly: true } }} fullWidth />
                  </FormControl>
                </Grid>
        
                <Grid item size={12}>
                  <Typography variant="h6">Services</Typography>
                  <Box sx={{ borderRadius: "8px", overflow: "hidden", border: "1px solid #ccc",marginY:3 }}>
  <Table>
    <TableHead>
      <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
        <TableCell><b>Service Name</b></TableCell>
        <TableCell><b>Features</b></TableCell>
        <TableCell><b>Quantity</b></TableCell>
        <TableCell><b>Templates</b></TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {services.map((service, index) => (
        <React.Fragment key={index}>
          <TableRow sx={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#f5f5f5" }}>
            <TableCell rowSpan={service.features.length + 1}>
              <Typography variant="subtitle1" fontWeight="bold">
                {service.serviceId.name}
              </Typography>
            </TableCell>
          </TableRow>
          {service.features.map((feature, idx) => (
            <TableRow key={idx} sx={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#f5f5f5" }}>
              <TableCell>{feature.key}</TableCell>
              <TableCell>
                <Typography slotProps={{ input: { readOnly: true } }} size="small" fullWidth>
                  {feature.value || "N/A"}
                </Typography>
              </TableCell>
              {idx === 0 && (
                <TableCell rowSpan={service.features.length}>
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {service.template?.map((tpl, tplIndex) => (
                      <Chip key={tplIndex} label={tpl.templateName || "N/A"} />
                    ))}
                  </Box>
                </TableCell>
              )}
            </TableRow>
          ))}
        </React.Fragment>
      ))}
    </TableBody>
  </Table>
</Box>

                </Grid>
        
                {/* <TemplateList title="Showcase Templates" templates={showcaseTemplate} /> */}
                <TemplateList title="Product Templates" templates={productTemplate} />
                <TemplateList title="Inspiration Templates" templates={inspirationTemplate} />
              </Grid>
            </Box>
          </Grid>
        </React.Fragment>
        
        );
      })}
    </Grid>
  );
};

export default PlanDetails;
